import { patch } from '..';

const updateChatSessionName = async (sessionId: string, newName: string) => {
  const requestUrl = `chatbot-api/chat-sessions/${sessionId}`;
  await patch(requestUrl, { name: newName });
};

export default updateChatSessionName;
